<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="page-headline">
                    <h2>{{pageTitle}}</h2>
                    <h1>{{subTitle}}</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="margin-top: 45px;">
                <head-image
                        v-bind:imgURL="'https://www.robinjuenkersfeld.de/img/projects/spaetlese-012.jpg'"
                        v-bind:imgTitle="'Spätlese - 16mm Kurzfilm'"
                        v-bind:aspectratio="aspectratio" >
                </head-image>
            </div>
        </div>

        <div class="row">
            <div class="col-12 vita-list">
                <ul>
                    <li>
                        <span class="vita-headline">2020 - heute</span>
                        <br />Freelance Editor & Colorist in Berlin vertreten durch <a href="https://boldbreed.de/" target="_blank"><b>BoldBreed</b></a>
                    </li>
                    <li>
                        <span class="vita-headline">2013 - 2020</span>
                        <br />Montage-Studium an der <a href="https://www.filmakademie.de/" target="_blank"><b>Filmakademie Baden-W&uuml;rttemberg</b></a>
                    </li>
                    <li>
                        <span class="vita-headline">2016-11 - 2017-04</span>
                        <br />Junior Colorist bei <a href="https://www.wefadetogrey.de/" target="_blank"><b>WeFadeToGrey</b></a>
                    </li>
                    <li>
                        <span class="vita-headline">2011 - 2013</span>
                        <br />Schnittleiter und Technische Leitung bei <a href="https://www.capture-mm.de/" target="_blank"><b>Capture Media</b></a>
                    </li>
                    <li>
                        <span class="vita-headline">2008 - 2011</span>
                        <br />Ausbildung zum Mediengestalter Bild und Ton bei <a href="https://www.capture-mm.de/" target="_blank"><b>Capture Media</b></a>
                    </li>
                </ul>
            </div>
        </div>

    </div>

</template>

<script>
    import HeadImage from "@/components/HeadImage.vue";
    import {mapState} from 'vuex';

    export default {
        name: "kontakt-page",
        metaInfo: {
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Kontaktdaten und wie Sie mich erreichen können.' },
                { name: 'robots', content: 'Index' }
            ],
            title: 'Kontakt'
        },
        props: {
            project: {},
        },
        components: {
            HeadImage: HeadImage
        },
        data: function() {
            return {
                pageTitle: "About",
                subTitle: "Vita",
            };
        },
        computed: mapState({
            aspectratio: state => state.config.aspectratio
        }),
    };
</script>





